export const convertToDescriptionApi = (description: string) => {
  return {
    id: description,
    description,
  };
};
